import { render, staticRenderFns } from "./SectionEight.vue?vue&type=template&id=3a8f0721&scoped=true&"
import script from "./SectionEight.vue?vue&type=script&lang=js&"
export * from "./SectionEight.vue?vue&type=script&lang=js&"
import style0 from "./SectionEight.vue?vue&type=style&index=0&id=3a8f0721&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8f0721",
  null
  
)

export default component.exports